"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTypeMap = void 0;
exports.DataTypeMap = {
    string: 'text',
    number: 'number',
    boolean: 'checkbox',
    Date: 'date',
    Time: 'time',
    DateTime: 'datetime-local',
    LongText: 'textarea',
    Rating: 'number',
    Color: 'color',
    TelephoneNumber: 'tel',
    EmailAddress: 'email',
    File: 'file',
    Hidden: 'hidden',
    Image: 'image',
    Month: 'month',
    Password: 'password',
    Radio: 'radio',
    Range: 'range',
    Search: 'search',
    URL: 'url',
    Week: 'week',
    any: 'text',
};
